// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 425) return "static/chunks/425-2b93f7aef4ca2953.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 225 ? "e78b34b7" : chunkId) + "." + {"50":"3f66844d5a6d9e31","213":"9b2ff62a83f5dbbc","225":"3cbdbda481c33895","238":"b2f8d6552e19cff4","347":"908dde1852dc56e7","457":"f83f9a7e804ab404","779":"5f78938ca3fdd68b","972":"97fb542c09ad4295"}[chunkId] + ".js";
};